
namespace TabAurous.JobWork{

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnBOMGrid extends Serenity.EntityGrid<JobWorkReturnBOMRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWorkReturnBOM'; }
        protected getDialogType() { return JobWorkReturnBOMDialog; }
        protected getIdProperty() { return JobWorkReturnBOMRow.idProperty; }
        protected getInsertPermission() { return JobWorkReturnBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReturnBOMRow.localTextPrefix; }
        protected getService() { return JobWorkReturnBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}